import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "post-board",
    style: { "width": "100%", "user-select": "none" }
};
var _hoisted_2 = {
    class: "post-show-container",
    style: { "display": "flex", "flex-direction": "column" }
};
var _hoisted_3 = { id: "post-aria" };
var _hoisted_4 = { class: "pages-nav" };
var _hoisted_5 = { class: "pages-btn-container" };
var _hoisted_6 = ["id", "onClick"];
import { onMounted, ref, toRef, watch } from "vue";
import PostBox from "@/components/BlogComponents/PostBoxRow.vue";
import NullView from "@/views/tipViews/Null.vue";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PostBoardRowShow',
    props: {
        target: String,
        mark: String,
        markvalue: String,
    },
    setup: function (__props) {
        var variants = {
            invisible: {
                opacity: 0,
                y: 20,
            },
            visible: function (custom) { return ({
                opacity: 1,
                y: 0,
                transition: { delay: custom * 0.3, ease: "easeInOut", duration: 0.4 },
            }); },
        };
        var attrprops = __props;
        var targetRef = toRef(attrprops, "target"), markRef = toRef(attrprops, "mark"), markvalue = toRef(attrprops, "markvalue");
        var posts = ref([]);
        var pagesNum = ref(1), //API获取
        selectedPage = ref(1); //当前页码
        var pagesContainerMark = ref([]);
        var isShowPagesLeft = ref(false), isShowPagesRight = ref(false);
        function setPage(page) {
            if (page < 1) {
                page = 1;
            }
            else if (page > pagesNum.value) {
                page = pagesNum.value;
            }
            else if (page == selectedPage.value) {
                return;
            }
            else {
                selectedPage.value = page;
            }
            if (targetRef.value !== undefined)
                api.request
                    .get(targetRef.value, {
                    params: {
                        offset: page,
                    },
                })
                    .then(function (resp) {
                    posts.value = resp.data;
                    resetPageMark();
                });
            else
                throw new Error("Post box targetRef is undefined");
        }
        function resetPageMark() {
            pagesContainerMark.value = [];
            if (pagesNum.value < 5) {
                for (var i = 0; i < pagesNum.value; i++) {
                    pagesContainerMark.value.push(i + 1);
                }
            }
            else {
                if (pagesNum.value - selectedPage.value < 2) {
                    for (var i = pagesNum.value - 4; i <= pagesNum.value; i++) {
                        pagesContainerMark.value.push(i);
                    }
                }
                else if (selectedPage.value <= 3) {
                    for (var i = 1; i < 6; i++) {
                        pagesContainerMark.value.push(i);
                    }
                }
                else {
                    for (var i = selectedPage.value - 2; i < selectedPage.value + 3; i++) {
                        pagesContainerMark.value.push(i);
                    }
                }
            }
        }
        function setShow() {
            if (targetRef.value === undefined)
                throw new Error("Post box targetRef is undefined");
            selectedPage.value = 1;
            api.request
                .get(targetRef.value, {
                params: {
                    offset: 1,
                },
            })
                .then(function (resp) {
                posts.value = resp.data;
            });
            api.request
                .get("/postnum?".concat(markRef.value, "=").concat(markvalue.value))
                .then(function (resp) {
                pagesNum.value = Math.ceil(resp.data.num / 12);
                resetPageMark();
            });
            if (pagesNum.value > 5) {
                isShowPagesLeft.value = true;
                isShowPagesRight.value = true;
            }
            resetPageMark();
        }
        onMounted(function () {
            watch(targetRef, function (newValue, oldValue) {
                setShow();
            });
        });
        setShow();
        return function (_ctx, _cache) {
            return (posts.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(posts.value, function (post, index) {
                                return (_openBlock(), _createBlock(PostBox, {
                                    key: "post-".concat(post.id),
                                    propPost: post
                                }, null, 8, ["propPost"]));
                            }), 128))
                        ]),
                        _createElementVNode("nav", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                (isShowPagesLeft.value)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "pages-left-btn pages-btn",
                                        onClick: _cache[0] || (_cache[0] = function ($event) { return (setPage(_unref(selectedPage) - 5)); })
                                    }, _cache[2] || (_cache[2] = [
                                        _createElementVNode("svg", {
                                            t: "1725936987250",
                                            class: "icon",
                                            viewBox: "0 0 1181 1024",
                                            version: "1.1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "p-id": "4269",
                                            width: "25",
                                            height: "25"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M580.77961928 191.51449556a42.80469896 42.80469896 0 0 0 0-62.15351819 46.88133702 46.88133702 0 0 0-64.49606383 0L151.21149665 480.95579306a42.80469896 42.80469896 0 0 0 0 62.12309574l365.0720588 351.56439249a46.88133702 46.88133702 0 0 0 64.49606383 0 42.80469896 42.80469896 0 0 0 0-62.15351741L248.01643764 511.98691812l332.82402727-320.47242256z m456.34007425 0a42.80469896 42.80469896 0 0 0 0-62.15351819 46.88133702 46.88133702 0 0 0-64.49606383 0l-365.07205955 351.56439325a42.80469896 42.80469896 0 0 0 0 62.12309498l365.07205955 351.56439326a46.88133702 46.88133702 0 0 0 64.49606383 0 42.80469896 42.80469896 0 0 0 0-62.15351818L704.35651113 511.98691812l332.82402727-320.47242256z",
                                                "p-id": "4270"
                                            })
                                        ], -1)
                                    ])))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagesContainerMark), function (item) {
                                    return (_openBlock(), _createElementBlock("span", {
                                        class: _normalizeClass(["pages-btn", ['pages-btn', { selected: item == _unref(selectedPage) }]]),
                                        id: "pagesBtn".concat(item),
                                        onClick: function ($event) { return (setPage(item)); }
                                    }, _toDisplayString(item), 11, _hoisted_6));
                                }), 256)),
                                (isShowPagesRight.value)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: "pages-right-btn pages-btn",
                                        onClick: _cache[1] || (_cache[1] = function ($event) { return (setPage(_unref(selectedPage) + 5)); })
                                    }, _cache[3] || (_cache[3] = [
                                        _createElementVNode("svg", {
                                            t: "1725937018326",
                                            class: "icon",
                                            viewBox: "0 0 1181 1024",
                                            version: "1.1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "p-id": "4425",
                                            width: "25",
                                            height: "25"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M586.24868164 191.51697751a42.80611491 42.80611491 0 0 1 0-62.1555745 46.88288738 46.88288738 0 0 1 64.49819742 0l365.08413414 351.57602211a42.80611491 42.80611491 0 0 1 0 62.12514976l-365.08413414 351.57602211a46.88288738 46.88288738 0 0 1-64.49819742 0 42.80611491 42.80611491 0 0 1 0-62.15557451L919.02287028 512 586.21825767 191.51697751z m-456.35516844 0a42.80611491 42.80611491 0 0 1 0-62.1555745 46.88288738 46.88288738 0 0 1 64.49819741 0l365.08413414 351.57602211a42.80611491 42.80611491 0 0 1 0 62.12514976l-365.08413414 351.57602211a46.88288738 46.88288738 0 0 1-64.49819741 0 42.80611491 42.80611491 0 0 1 0-62.15557451L462.66770184 512 129.86309 191.51697751z",
                                                "p-id": "4426"
                                            })
                                        ], -1)
                                    ])))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]))
                : (_openBlock(), _createBlock(NullView, { key: 1 }));
        };
    }
});
